import { createFileRoute } from "@tanstack/react-router";

// Phòng máy (QĐ 0541): /hunch-room?tab=thu|luat|nguoi|so. Thiếu = thu.
export type HunchRoomTab = "thu" | "luat" | "nguoi" | "so";
const TABS: readonly HunchRoomTab[] = ["thu", "luat", "nguoi", "so"];

export type HunchRoomSearch = { tab?: HunchRoomTab | undefined };

export const Route = createFileRoute("/_app/hunch-room")({
  validateSearch: (search: Record<string, unknown>): HunchRoomSearch => {
    const tab = search.tab;
    return typeof tab === "string" && (TABS as readonly string[]).includes(tab) ? { tab: tab as HunchRoomTab } : {};
  },
});
